<template>
    <div>
        <div class="col-md-12 p-0  pt-10 mx-auto" style="border: none!important;">
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                           v-on="on"><span class="material-icons">refresh</span>
                    </v-btn>
                </template>
                <span>به روز رسانی لیست تاریخچه ها</span>
            </v-tooltip>
            <v-dialog
                    v-if="showDescrption"
                    v-model="showDescrption"
                    max-width="600"
                    hide-overlay
                    transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar
                            flat
                            dark
                            color="primary"
                    >
                        <v-toolbar-title>توضیحات</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                    icon
                                    dark
                                    @click="showDescrption = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <div class="p-10">
                        <p>مذاکرات انجام شده :</p>
                        <p v-html="myDesc"></p>
                        <hr>
                        <p>موارد پیگیری در تماس بعدی :</p>
                        <p v-html="myPurpose"></p>
                    </div>
                </v-card>
            </v-dialog>

            <!--      end edit mode -->
            <v-card :loading="loading" class="p-3 mt-10 mx-2">
                <div class="mb-4">
                    <v-btn @click="historyModal=true" class="submit-btn">ایجاد تاریخچه جدید</v-btn>
                    <template>
                        <v-row justify="center">
                            <v-dialog
                                    v-if="historyModal"
                                    v-model="historyModal"
                                    max-width="1200"
                                    hide-overlay
                                    transition="dialog-bottom-transition"
                            >
                                <v-card>
                                    <v-toolbar
                                            flat
                                            dark
                                            color="primary"
                                    >

                                        <v-toolbar-title>ایجاد تاریخچه ها</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items>
                                            <v-btn
                                                    icon
                                                    dark
                                                    @click="historyModal = false"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-toolbar-items>
                                    </v-toolbar>
                                    <add-history :reload="()=>{reloadTable(tableProps)}" :id="id"
                                                 :modal="()=>{historyModal = false}" :customer="!estate"></add-history>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                    v-if="showMore"
                                    v-model="showMore"
                                    max-width="1200"
                                    hide-overlay
                                    transition="dialog-bottom-transition"
                            >
                                <v-card>
                                    <v-toolbar
                                            flat
                                            dark
                                            color="primary"
                                    >

                                        <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items>
                                            <v-btn
                                                    icon
                                                    dark
                                                    @click="showMore = false"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-toolbar-items>
                                    </v-toolbar>
                                    <more-information :information="related_id"></more-information>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </template>
                </div>


                <terminal-table class="col-12" :currentPage="datas.current_page"
                                :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                :pageCount="datas.last_page"
                                :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                <data-table
                        v-else
                        :data="datas"
                        :columns="columns"
                        :debounce-delay="3000"
                        :pagination="paginate"
                        :orderBy="tableProps.column"
                        :orderDir="tableProps.dir"
                        :translate="translate"
                        :per-page="[10, 25, 50, 100, 500]"
                        @on-table-props-changed="reloadTable"
                        class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                ></data-table>
            </v-card>
        </div>
    </div>
</template>

<script>
import {debounce} from "@/custom";
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import AddHistory from "../addHistory";

export default {
    name: "listHistory",
    components: {AddHistory},
    props: {
        id: {
            default: ''
        },
        estate: {
            default: false
        },
    },
    data() {
        return {
            loading: false,
            historyModal: false,
            showDescrption: false,
            related_id: null,
            datas: {},
            mine: [],
            myRes: [],
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/history/estate`,
            selectedNumber: [],
            translates: [],
            dataId: '',
            adsList: '',
            myDesc: '',
            myPurpose: '',
            nowTime: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'عنوان ',
                    name: 'title',
                    primary: true,
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مرحله ',
                    name: 'step',
                    transform(val) {
                        return `<span>${val.data.step !== null ? val.data.step : '-'}</span>`
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان یادآور',
                    name: 'remind_date',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان آخرین تماس',
                    name: 'created_at_p',
                    transform(val) {
                        return `<span>${val.data.created_at_p !== null ? val.data.created_at_p : '-'}</span>`
                    },
                    orderable: true,
                    searchable: true,
                },
                // {
                //     label: 'توضیحات',
                //     name: 'description',
                //     transform(val){
                //       return `<p class="text-truncate" style="max-width: 1rem">${val.data.description}</p>`
                //     },
                //     orderable: true,
                //     searchable: true,
                // },
                {
                    label: 'ثبت کننده',
                    name: 'user',
                    transform(val) {
                        return `<p>${val.data.user.name + ' ' + val.data.user.lastName}</p>`
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'desc',
                                label: 'نمایش توضیحات',
                                icon: 'list',
                                class: 'btn-outline-info',
                                action: this.actions,
                            },

                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],
        }
    },
    methods: {
        translator(name) {
            return this.translates.data[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;

            vm.datas = [];
            vm.loading = true;

            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این تاریخچه اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: this.officers_id === 'لیست تاریخچه املاک' ? `${url}/user/history/estate/${data.id}` : `${url}/user/history/customer/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        descAction(data) {
            this.showDescrption = true;
            this.myDesc = data.description;
            this.myPurpose = data.purpose;
        },
        showAction: function (data) {
            this.showMore = true;
            this.related_id = data.id
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) !== 'string') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                fn: this.getTimesForNow,
                type: 'GET',
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.nowTime = data.data.time_stamp;
                }
            });
        }
    },
    watch: {
        estate(value) {
            if (value) {
                this.url = `${url}/user/history/estate?estate_id=${this.id}`;
                this.getDataForTable(this.url);
            } else {
                this.url = `${url}/user/history/customer?customer_id=${this.id}`;
                this.getDataForTable(this.url);
            }
        },
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },
    mounted() {
        if (this.estate) {
            this.url = `${url}/user/history/estate?estate_id=${this.id}`;
            this.getDataForTable(this.url);
        } else {
            this.url = `${url}/user/history/customer?customer_id=${this.id}`;
            this.getDataForTable(this.url);
        }
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
}

</script>